import emailjs from 'emailjs-com';

/**
 * Sends an order confirmation email with download links using EmailJS with SMTP
 * 
 * @param {Object} orderDetails - Order information
 * @param {string} orderDetails.orderId - The order ID
 * @param {string} orderDetails.userEmail - Customer's email address
 * @param {string} orderDetails.userName - Customer's name
 * @param {number} orderDetails.totalAmount - Total purchase amount
 * @param {Array} orderDetails.examData - Detailed information about purchased exams
 * @returns {Promise} - Promise resolving to the EmailJS response
 */
const sendOrderConfirmationEmail = async (orderDetails) => {
  const { orderId, userEmail, userName, totalAmount, examData } = orderDetails;

  // Get base URL for absolute links
  const baseUrl = window.location.origin;
  
  // Create HTML for download links grouped by exam
  let downloadLinksHtml = '';
  
  examData.forEach(exam => {
    downloadLinksHtml += `
      <div style="margin-bottom: 15px;">
        <h3 style="margin-bottom: 8px; color: #4636FF;">${exam.name}</h3>
        <ul style="padding-left: 20px;">
    `;
    
    exam.papers.forEach(paper => {
      const paperUrl = `${baseUrl}/mocktest-files/${exam.id}/${paper.replace(/\s+/g, '-').toLowerCase()}.pdf`;
      downloadLinksHtml += `
        <li style="margin-bottom: 5px;">
          <a href="${paperUrl}" style="color: #4636FF; text-decoration: underline;">${paper}</a>
        </li>
      `;
    });
    
    downloadLinksHtml += `
        </ul>
      </div>
    `;
  });
  
  // Format the order date nicely
  const orderDate = new Date().toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  });
  
  // Generate the items list for the order summary
  const itemsList = examData.map(exam => {
    return `${exam.name} - ₹${exam.price}`;
  }).join('<br>');
  
  // Prepare template parameters
  const templateParams = {
    // SMTP configuration
    smtp_host: 'smtp.gmail.com', // Using Gmail's SMTP server
    smtp_port: '587', // Using port 587 for TLS
    smtp_user: 'rakshith.sconti@gmail.com', // The username is usually the email address
    smtp_password: 'Samai@2025', // Your email password or app password
    smtp_secure: 'false', // Use false for STARTTLS on port 587
    // You may need to specify the TLS version explicitly
    smtp_tls_options: JSON.stringify({
      minVersion: 'TLSv1.2'
    }),
    
    // Email content
    to_email: userEmail, // Must be provided when calling this function
    to_name: userName || 'Valued Customer',
    recipient: userEmail, // Alternative parameter name for recipient
    email: userEmail,     // Another alternative parameter name
    
    subject: `Your Samai Mocktests Order Confirmation #${orderId}`,
    user_name: userName || 'Valued Customer',
    order_id: orderId,
    order_date: orderDate,
    total_amount: totalAmount,
    items_list: itemsList,
    download_links_html: downloadLinksHtml,
    company_name: 'Samai Mocktests',
    company_address: 'Your Company Address',
    company_email: 'support@samaimocktests.com',
    company_phone: '+91 9876543210',
    company_website: 'samaimocktests.com',
    
    // Sender information
    from_name: 'Samai Mocktests',
    from_email: 'rakshith.sconti@gmail.com', // Using the sender address from Firebase
    reply_to: 'rakshith.sconti@gmail.com'
  };

  // Log the parameters for debugging
  console.log('Sending email with params:', JSON.stringify(templateParams, null, 2));

  try {
    // Initialize EmailJS with your public key
    emailjs.init('--hk3CTZzkT7V5LZZ');  // Your public key
    
    // Send email through EmailJS with SMTP configuration
    const response = await emailjs.send(
      'service_8zc5b9n',      // EmailJS SMTP service ID
      'template_qnem136',     // EmailJS template ID
      templateParams
    );
    
    console.log('Email sent successfully:', response);
    return {
      success: true,
      message: 'Order confirmation email sent successfully',
      response
    };
  } catch (error) {
    console.error('Error sending email:', error);
    return {
      success: false,
      message: 'Failed to send order confirmation email',
      error
    };
  }
};

export default sendOrderConfirmationEmail;